// extracted by mini-css-extract-plugin
module.exports = {"cards":"AssessmentsTeaser_cards__3EuEq","feature":"AssessmentsTeaser_feature__3JT3M"};